/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Organizationsettings_Leavecancel2Inputs */

const zh_organizationsettings_leavecancel2 = /** @type {(inputs: Organizationsettings_Leavecancel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`取消`)
};

const en_organizationsettings_leavecancel2 = /** @type {(inputs: Organizationsettings_Leavecancel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cancel`)
};

const es_organizationsettings_leavecancel2 = /** @type {(inputs: Organizationsettings_Leavecancel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cancelar`)
};

/**
* | output |
* | --- |
* | "Cancel" |
*
* @param {Organizationsettings_Leavecancel2Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const organizationsettings_leavecancel2 = /** @type {((inputs?: Organizationsettings_Leavecancel2Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Organizationsettings_Leavecancel2Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_organizationsettings_leavecancel2(inputs)
	if (locale === "en") return en_organizationsettings_leavecancel2(inputs)
	return es_organizationsettings_leavecancel2(inputs)
});
export { organizationsettings_leavecancel2 as "organizationSettings_leaveCancel" }